const skills =
  [
    {
      category: 'Backend',
      languages:
      [
        {
          name: 'java',
          id: 0,
          good: 2,
          max: 10
        },
        {
          name: 'php',
          id: 1,
          good: 1,
          max: 10
        },
        {
          name: 'c',
          id: 2,
          good: 0,
          max: 10
        },
        {
          name: 'c++',
          id: 3,
          good: 0,
          max: 10
        },
        {
          name: 'python',
          id: 5,
          good: 0,
          max: 10
        }
      ],
      icon: 'icon_cloud'
    },
    {
      category: 'Front-end',
      languages:
      [
        {
          name: 'javascript',
          id: 0,
          good: 1,
          max: 10
        },
        {
          name: 'HTML',
          id: 1,
          good: 1,
          max: 10
        },
        {
          name: 'CSS',
          id: 2,
          good: 1,
          max: 10
        }
      ],
      icon: 'icon_desktop'
    },
    {
      category: 'Frameworks',
      languages:
      [
        {
          name: 'Vue',
          id: 1,
          good: 0,
          max: 10
        },
        {
          name: 'React',
          id: 2,
          good: 0,
          max: 10
        },
        {
          name: 'Angular',
          id: 3,
          good: 0,
          max: 10
        }
      ],
      icon: 'icon_tools'
    },
    {
      category: 'Systems',
      languages:
      [
        {
          name: 'Windows',
          id: 1,
          good: 7,
          max: 10
        },
        {
          name: 'Mac OS X',
          id: 2,
          good: 7,
          max: 10
        },
        {
          name: 'Linux/Unix',
          id: 3,
          good: 3,
          max: 10
        }
      ],
      icon: 'icon_genius'
    }
  ]

const projects = [
  {
    name: 'project1',
    type: '(personal project)',
    description: 'project 1 description of what it does and accomplishes'
  },
  {
    name: 'project2',
    type: '(personal project)',
    description: 'project 2 description of what it does and accomplishes'
  }
]

const jobs = [
  {
    company: 'University of North Georgia',
    id: 's5',
    title: 'Student',
    start: '2016.8',
    end: 'present'
  },
  {
    company: 'Sam\'s Club',
    id: 's4',
    title: 'Tire Technician',
    start: '2015.8',
    end: 'present'
  },
  {
    company: 'Monsignor Donovan High School',
    id: 's3',
    title: 'Student',
    start: '2014.8',
    end: '2016.5'
  },
  {
    company: 'Oglethorpe County High School',
    id: 's2',
    title: 'Student',
    start: '2012.8',
    end: '2014.5'
  }
]

const myStory = {
  summary: 'Hi! I\'m Brandon Pinto. My Background is in CS with an emphasis in Software Engineer',
  story: `As a student and worker, I am dedicated
  to continual self-development, and I have an eye for detail and identifying problems. I am willing learn from
  my mistakes as I navigate new environments and challenges. I am ready to continue honing my expertise with
  other talented professionals.`
}

const jobsDesc = [
  {
    id: 's2',
    year: '2012',
    description: `I attended Oglethorpe County High school where I juggled Academia and Soccer. I ended up getting a
    3.2 GPA and a soccer scholorship to attend Monsignor Donovan High School (private school).`
  },
  {
    id: 's3',
    year: '2014',
    description: `I was able to attend Monsignor Donovan High School on a soccer scholarship where I graduated with a
    3.4 GPA. I also received all star state soccer player status once, All region player three times, MVP twice,
    and our team came in 4th overall state. Furthermore, I ended the year with over 40 hours of community service`
  },
  {
    id: 's4',
    year: '2015',
    description: `I currently work at Sam's as a Tire Technician. Before, I was a cashier handling transaction but decided
    to switch position because I enjoy learning new skills and improving myself`
  },
  {
    id: 's5',
    year: '2016',
    description: `I currently attend the University of North Georgia where I am pursuing a degree in Computer Science with an
    emphasis in Software Engineer. I currently have a 3.5 GPA and hope to transfer to the University of Georgia where I can finish
    getting my Bachelor's degree`
  }
]

export {
  skills,
  projects,
  jobs,
  myStory,
  jobsDesc
}



// WEBPACK FOOTER //
// ./src/data.js